'use client';

import type { ReactNode } from 'react';
import { useCallback } from 'react';
import { usePromotionLauncher } from '@/hooks/use-promotion-launcher/use-promotion-launcher.hook';
import { PromotionGameLauncher } from '@/hooks/use-promotion-launcher/promotion-game-launcher';
import { ddRumAction } from '@/utils/datadog';
import { ddActionPokerTournamentTicketLaunched } from '@/utils/datadog/poker';

export type PokerTournamentTicketGameLauncherWrapperProps = {
    children: ReactNode;
    providedLaunchUrl: string;
};

export const PokerTournamentTicketGameLauncherWrapper = ({
    children,
    providedLaunchUrl
}: PokerTournamentTicketGameLauncherWrapperProps) => {
    const { handleGameLaunch } = usePromotionLauncher();

    const handleGameLaunchWithLogging = useCallback(
        (url: string) => {
            ddRumAction(ddActionPokerTournamentTicketLaunched({ url }));
            handleGameLaunch(url);
        },
        [handleGameLaunch]
    );

    return (
        <PromotionGameLauncher url={providedLaunchUrl} onLaunch={handleGameLaunchWithLogging}>
            {children}
        </PromotionGameLauncher>
    );
};

PokerTournamentTicketGameLauncherWrapper.displayName = 'PokerTournamentTicketGameLauncherWrapper';
